const formDataFromBase64 = async (name: string, base64: string) => {
  const blobImage = await (await fetch(base64)).blob();
  const formData = new FormData();
  formData.append(name, blobImage);
  return formData;
};

export { formDataFromBase64 };
